var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "relative w-full text-left"
  }, [_c('div', {
    staticClass: "relative"
  }, [_c('div', {
    class: ['w-full px-3 border rounded-md cursor-pointer flex items-center gap-2', _vm.isError ? 'border-red-300' : 'border-gray-300 hover:border-gray-400', _vm.isError && _vm.selectedValues.length === 0 ? 'bg-red-300' : 'bg-gray-50'],
    on: {
      "click": _vm.toggleDropdown
    }
  }, [_c('div', {
    staticClass: "flex items-center flex-1 h-full gap-1 py-2 overflow-x-auto"
  }, [_vm._l(_vm.selectedOptions, function (option) {
    return _c('div', {
      key: option.value,
      staticClass: "inline-flex items-center px-2 py-0.5 text-xs text-blue-800 bg-blue-100 rounded-lg flex-shrink-0 h-6"
    }, [_c('span', [_vm._v(_vm._s(option.text || option.name))]), _c('button', {
      staticClass: "ml-1 text-sm leading-none text-blue-600 hover:text-blue-800 focus:outline-none",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.removeOption(option.value);
        }
      }
    }, [_vm._v(" × ")])]);
  }), _vm.selectedValues.length === 0 ? _c('span', {
    staticClass: "flex-shrink-0 text-sm",
    class: _vm.isError ? 'text-red-500' : 'text-gray-500',
    style: {
      padding: '2px 0'
    }
  }, [_vm._v(" " + _vm._s(_vm.defaultText) + " ")]) : _vm._e()], 2), _c('ChevronDownFilled', {
    attrs: {
      "className": "h-3 w-3 text-gray-500 pointer-events-none flex-shrink-0"
    }
  })], 1)]), _vm.isOpen ? _c('div', {
    staticClass: "absolute right-0 z-10 w-full mt-1 bg-white border rounded-md shadow-sm ring-1 ring-black ring-opacity-5"
  }, [_c('div', {
    staticClass: "p-1"
  }, _vm._l(_vm.options, function (option) {
    return _c('label', {
      key: option.value,
      staticClass: "flex items-center p-2 m-0 cursor-pointer hover:bg-gray-100",
      on: {
        "click": function ($event) {
          return _vm.selectOption(option);
        }
      }
    }, [_c('input', {
      staticClass: "w-4 h-4 text-blue-600 form-checkbox",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": option.value,
        "checked": _vm.selectedValues.includes(option.value)
      },
      on: {
        "change": function ($event) {
          return _vm.handleCheckboxChange(option);
        }
      }
    }), _c('span', {
      staticClass: "ml-2 text-gray-700"
    }, [_vm._v(_vm._s(option.text || option.name))])]);
  }), 0)]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }